export const SHARD_LOAD_SUCCESS = 'shard/LOAD_SUCCESS';
export const SHARD_CHANGE_SUCCESS = 'shard/CHANGE_SUCCESS';
export const SHARD_CREATE_SUCCESS = 'shard/CREATE_SUCCESS';
export const SHARD_EDIT_SUCCESS = 'shard/EDIT_SUCCESS';
export const SHARD_DELETE_SUCCESS = 'shard/DELETE_SUCCESS';
export const SET_BUSY = 'shard/SET_BUSY';
export const UNSET_BUSY = 'shard/UNSET_BUSY';
